import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=e9bae250&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9bae250')) {
      api.createRecord('e9bae250', component.options)
    } else {
      api.reload('e9bae250', component.options)
    }
    module.hot.accept("./DashboardChart.vue?vue&type=template&id=e9bae250&", function () {
      api.rerender('e9bae250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/DashboardChart.vue"
export default component.exports